import React from "react";
import { Grid, TextField } from '@mui/material';
import moment from "moment";

export default function FormPreciosEspeciales(props) {
    const { style, size, almacenar, datoslista } = props;

    const handleKeyDown = (e) => {
        // Permitir números y la coma
        if (!(
            (e.key >= '0' && e.key <= '9') ||
            e.key === ',' ||
            e.key === 'Backspace' ||  // permitir borrar
            e.key === 'ArrowLeft' ||   // permitir mover cursor
            e.key === 'ArrowRight' ||
            e.key === 'Tab'             // permitir tabular
        )) {
            e.preventDefault();
        }
    }

    return (
        <>
            {datoslista &&
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                    mt={1}
                    ml={1}
                    mr={1}
                >
                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            size={size}
                            style={style}
                            focused
                            color="primary"
                            required
                            name="lt_sin_iva"
                            label="Precio litro sin IVA"
                            variant="outlined"
                            value={datoslista.lt_sin_iva ?? ''}
                            onChange={almacenar}
                            onKeyDown={(e) => { handleKeyDown(e) }}
                            onPaste={(e) => {
                                const pastedText = e.clipboardData.getData('text');
                                if (pastedText.includes('.')) {
                                    e.preventDefault();
                                }
                            }}
                            inputProps={{
                                inputMode: 'decimal',
                                pattern: '[0-9]*[,]{0,1}[0-9]{0,2}',
                            }}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            size={size}
                            style={style}
                            focused
                            color="primary"
                            required
                            name="lt_con_iva"
                            label="Precio litro con IVA"
                            variant="outlined"
                            value={datoslista.lt_con_iva ?? ''}
                            onChange={almacenar}
                            onKeyDown={(e) => {
                                if (e.key === '.') {
                                    e.preventDefault();
                                }
                            }}
                            onPaste={(e) => {
                                const pastedText = e.clipboardData.getData('text');
                                if (pastedText.includes('.')) {
                                    e.preventDefault();
                                }
                            }}
                            inputProps={{
                                inputMode: 'decimal',
                                pattern: '[0-9]*[,]{0,1}[0-9]{0,2}',
                            }}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            size={size}
                            style={style}
                            focused
                            color="primary"
                            required
                            name="kg_sin_iva"
                            label="Precio kilo sin IVA"
                            variant="outlined"
                            value={datoslista.kg_sin_iva ?? ''}
                            onKeyDown={(e) => {
                                if (e.key === '.') {
                                    e.preventDefault();
                                }
                            }}
                            onPaste={(e) => {
                                const pastedText = e.clipboardData.getData('text');
                                if (pastedText.includes('.')) {
                                    e.preventDefault();
                                }
                            }}
                            inputProps={{
                                inputMode: 'decimal',
                                pattern: '[0-9]*[,]{0,1}[0-9]{0,2}',
                            }}
                            onChange={almacenar}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            size={size}
                            style={style}
                            focused
                            color="primary"
                            required
                            name="kg_con_iva"
                            label="Precio kilo con IVA"
                            variant="outlined"
                            value={datoslista.kg_con_iva ?? ''}
                            onKeyDown={(e) => {
                                if (e.key === '.') {
                                    e.preventDefault();
                                }
                            }}
                            onPaste={(e) => {
                                const pastedText = e.clipboardData.getData('text');
                                if (pastedText.includes('.')) {
                                    e.preventDefault();
                                }
                            }}
                            inputProps={{
                                inputMode: 'decimal',
                                pattern: '[0-9]*[,]{0,1}[0-9]{0,2}',
                            }}
                            onChange={almacenar}
                        />
                    </Grid>

                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            size={size}
                            style={style}
                            focused
                            color="primary"
                            required
                            type="date"
                            name="vigencia"
                            label="Vigencia"
                            variant="outlined"
                            value={datoslista.vigencia}
                            onChange={almacenar}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            size={size}
                            style={style}
                            focused
                            color="primary"
                            type="date"
                            name="fin_vigencia"
                            label="Fin vigencia"
                            variant="outlined"
                            value={datoslista.fin_vigencia}
                            onChange={almacenar}
                        />
                    </Grid>
                </Grid>
            }
        </>
    )
}
//----- Component --------------------------------------------------------/
// Developer :  Candela Grosso
// Creation Date: 12/09/2024
// Version : 1
// Description : formulario para agregar precios, solo tngo los textfields y eso
//------Changes ----------------------------------------------------------//
// Change by : Candela Grosso
// Change description:  separo los decimales con coma y dos

// Change Date :03/07/2025
//========================================================================/
//========================================================================/